
import { Col, Row } from 'reactstrap';
import ValidationField from '../../../Components/ValidationField/ValidationField';
import React from 'react';
import { useFormikContext } from 'formik';

function Form() {

  const typeselect = [
    { label: "home", value: "home" },
    { label: "setting", value: "setting" },
    { label: "contact_us", value: "contact_us" },
    { label: "about_us", value: "about_us" }


  ]
  const typeValueselect = [
    { label: "image", value: "image" },
    { label: "text", value: "text" },

  ]
  const {values, setFieldValue } = useFormikContext<any>()
  const [valueType, setvalueType] = React.useState<"image" | "text">(values?.value_type)
  const handelchange = () => {
    setFieldValue("value", null)
    if (valueType === "image") {
      setvalueType("text")
      setFieldValue("value_type", "text")

    } else {
      setvalueType("image")
      setFieldValue("value_type", "image")

    }

  }
  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>
        <ValidationField name="key" isDisabled  />


      </Col>
      <Col>
        {/* <ValidationField name="type" type='Select' option={typeselect} /> */}

        {valueType === "text"
          ?
          <ValidationField name="value" />

          :
          <ValidationField type='File' name="value" />

        }
        {/* <ValidationField name="value_type" onChange={handelchange} type='Select' option={typeValueselect} /> */}

      </Col>



    </Row>
  )
}

export default Form




